'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createAudioParam;

var _pseudoAudioParam = require('pseudo-audio-param');

var _pseudoAudioParam2 = _interopRequireDefault(_pseudoAudioParam);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _lodash = require('lodash.isnumber');

var _lodash2 = _interopRequireDefault(_lodash);

var _coreDecorators = require('core-decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var globalContext = typeof global !== 'undefined' ? global : window;
var AudioContextConstructor = globalContext.AudioContext || globalContext.webkitAudioContext;

/**
 * Returns a constructor/class/function that looks and acts just like an
 * `AudioParam` instance, except it doesn't actually touch any web audio
 * stuff. Instead, one can subscribe for value changes and then do whatever
 * one wants with that value.
 *
 * @param  {String} name          The parameter's name
 * @param  {Number} defaultValue  The parameter's default value
 * @param  {Number} minValue      The parameter's minimum value
 * @param  {Number} maxValue      The parameter's maximum value
 * @return {Function}             A AudioParamShim class
 */
function createAudioParam(name, defaultValue, minValue, maxValue) {
  var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  // Check that we have an `(webkit)AudioContext`
  if (AudioContextConstructor === undefined) {
    throw new TypeError('Neither AudioContext nor webkitAudioContext is available on the global scope. ' + 'If you\'re in a node.js environment you need to polyfill it, ' + 'perhaps with https://github.com/sebpiq/node-web-audio-api?');
  }

  // Make sure we have what we need
  (0, _invariant2.default)(typeof name === 'string' && name.trim().length > 0, 'You must provide a non-empty parameter name to createAudioParam(name, defaultValue, minValue, maxValue)');
  (0, _invariant2.default)((0, _lodash2.default)(defaultValue), 'You must provide a numeric default value to createAudioParam(name, defaultValue, minValue, maxValue)');
  (0, _invariant2.default)((0, _lodash2.default)(minValue), 'You must provide a numeric min value to createAudioParam(name, defaultValue, minValue, maxValue)');
  (0, _invariant2.default)((0, _lodash2.default)(maxValue), 'You must provide a numeric max value to createAudioParam(name, defaultValue, minValue, maxValue)');
  (0, _invariant2.default)(defaultValue >= minValue, 'The default value ' + defaultValue + ' cannot be lesser than the minimum value ' + minValue);
  (0, _invariant2.default)(defaultValue <= maxValue, 'The default value ' + defaultValue + ' cannot be greater than the maximum value ' + maxValue);

  /**
   * A bespoke, hand-crafted audio param shim class having the
   * same API as real `AudioParam`.
   */
  var AudioParamShim = (_class = function (_PseudoAudioParam) {
    _inherits(AudioParamShim, _PseudoAudioParam);

    /**
     * Constructor
     *
     * @param  {AudioContext} context  An AudioContext instance
     * @return {Function}              A custom audio param constructor
     * @throws {TypeError}             If context is not an instance if `(webkit)AudioContext`
     */
    function AudioParamShim(context) {
      _classCallCheck(this, AudioParamShim);

      var _this = _possibleConstructorReturn(this, (AudioParamShim.__proto__ || Object.getPrototypeOf(AudioParamShim)).call(this));

      _initDefineProp(_this, 'name', _descriptor, _this);

      _initDefineProp(_this, '_subscribers', _descriptor2, _this);

      _initDefineProp(_this, 'defaultValue', _descriptor3, _this);

      _initDefineProp(_this, 'minValue', _descriptor4, _this);

      _initDefineProp(_this, 'maxValue', _descriptor5, _this);

      if (context instanceof AudioContextConstructor === false) {
        throw new TypeError('The provided context is not an AudioContext or webkitAudioContext');
      }

      _this.context = context;
      _this.value = _this.defaultValue;

      var currentValue = _this.value;

      var update = function update() {
        if (currentValue !== _this.value) {
          _this._subscribers.forEach(function (fn) {
            return fn(currentValue);
          });
          currentValue = _this.value;
        }

        if (typeof window !== 'undefined') {
          window.requestAnimationFrame(update);
        } else {
          setTimeout(update, 16); // 60 fps
        }
      };

      update();
      return _this;
    }

    /**
     * The parameter's name
     */


    /**
     * An array of callback functions that gets notify of value changes
     */


    _createClass(AudioParamShim, [{
      key: 'subscribe',


      /**
       * Adds a functions to the list of callback functions that are invoked
       * with the parameter's value whenever it changes.
       *
       * @param  {Function} fn  A callback function
       */
      value: function subscribe(fn) {
        this._subscribers = [].concat(_toConsumableArray(this._subscribers), [fn]);
      }

      /**
       * Removes a function from the list of callback functions that are invoked
       * with the parameter's value whenever it changes.
       *
       * @param  {Function} fn  The callback function to remove
       */

    }, {
      key: 'unsubscribe',
      value: function unsubscribe(fn) {
        this._subscribers = this._subscribers.filter(function (subscriber) {
          return subscriber !== fn;
        });
      }
    }, {
      key: 'value',


      /**
       * Returns the parameter's current value
       *
       * @return {Number} The parameter's current value
       */
      get: function get() {
        return this.getValueAtTime(this.context.currentTime);
      }

      /**
       * Sets the parameter's value to a new value. The new value is clamped inside
       * to range given by `minValue` and `maxValue`.
       *
       * @param  {Number} value  A new value
       */
      ,
      set: function set(value) {
        var clampedValue = value;

        if (value > this.maxValue) {
          console.warn('The value ' + value + ' is greater than the max value ' + this.maxValue);
          clampedValue = this.maxValue;
        }
        if (value < this.minValue) {
          console.warn('The value ' + value + ' is lesser than the min value ' + this.minValue);
          clampedValue = this.minValue;
        }

        this.setValueAtTime(clampedValue, this.context.currentTime);
      }

      /**
       * The parameter's default value
       */


      /**
       * The parameter's minimum value
       */


      /**
       * The parameter's maximum value
       */

    }]);

    return AudioParamShim;
  }(_pseudoAudioParam2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'name', [_coreDecorators.nonenumerable, _coreDecorators.nonconfigurable, _coreDecorators.readonly], {
    enumerable: true,
    initializer: function initializer() {
      return name.trim();
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, '_subscribers', [_coreDecorators.nonenumerable], {
    enumerable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'defaultValue', [_coreDecorators.readonly, _coreDecorators.nonconfigurable], {
    enumerable: true,
    initializer: function initializer() {
      return defaultValue;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'minValue', [_coreDecorators.readonly, _coreDecorators.nonconfigurable], {
    enumerable: true,
    initializer: function initializer() {
      return minValue;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'maxValue', [_coreDecorators.readonly, _coreDecorators.nonconfigurable], {
    enumerable: true,
    initializer: function initializer() {
      return maxValue;
    }
  })), _class);


  return AudioParamShim;
}